import { ValueProvider } from '@angular/core';
import { User, UserDetailed, UserDetailedInterface, UserInterface } from 'app/core/user/models';
import { Observable, of, throwError } from 'rxjs';

import { UserServiceInterface } from './user-service.interface';
import { UserService } from './user.service';

const detailedUserTest: UserDetailedInterface = new UserDetailed(
  {
    user: {
      profileFilterValues: [
        {
          value: '-1',
          label: '',
          filterId: '4',
          filterLabel: 'City',
        },
        {
          value: '-1',
          label: '',
          filterId: '5',
          filterLabel: 'Division',
        },
        {
          value: '-1',
          label: '',
          filterId: '1',
          filterLabel: 'Department',
        },
        {
          value: '-1',
          label: '',
          filterId: '2',
          filterLabel: 'Job Title',
        },
        {
          value: '-1',
          label: '',
          filterId: '3',
          filterLabel: 'Building',
        },
      ],
      customFieldValues: [
        {
          id: '1',
          label: 'Supervisors Name',
          value: '',
        },
        {
          id: '2',
          label: 'Supervisors Email',
          value: '',
        },
        {
          id: '3',
          label: 'Supervisors Phone Number',
          value: '',
        },
        {
          id: '4',
          label: 'EH&S/Workers Comp Contact Name',
          value: '',
        },
        {
          id: '5',
          label: 'Job Description',
          value: '',
        },
        {
          id: '6',
          label: 'EH&S/Workers Comp Contact Phone Number',
          value: '',
        },
      ],
      displayName: 'survey, new - new survey',
      primaryPhone: '(303) 565-8515',
      primaryEmail: 'dbardal@ibrtek.com',
      secondaryEmail: 'dbardal@ibrtek.com',
      gender: 2,
      userDisabled: false,
      isAdminUser: false,
      hasFullDataAccess: true,
      roleId: 8,
      roleLabel: 'Employee',
      id: 473,
      userName: 'new survey',
      firstName: 'new',
      lastName: 'survey',
      tcAccept: true,
    },
    discomfort: 'Constant',
    discomfortValue: 4,
    risk: 'High',
    riskValue: 894,
    numAssessments: 3,
  },
);

export class UserServiceStub implements UserServiceInterface {

  constructor(private readonly _user: UserInterface, private readonly _alwaysError: boolean = false) { }

  public updateUser(user: UserInterface): Observable<UserInterface> {
    return this._alwaysError ? throwError('') : of(user);
  }

  public loadAll(): Observable<UserInterface[]> {
    return this._alwaysError ? throwError('') : of([this._user]);
  }

  public loadAllDetailed(): Observable<UserDetailedInterface[]> {
    return this._alwaysError ? throwError('') : of([detailedUserTest]);
  }

  public getSelectedUser(): Observable<UserInterface> {
    return this._alwaysError ? throwError('') : of(this._user);
  }

  public getDetailedSelectedUser(): Observable<UserDetailedInterface> {
    return this._alwaysError ? throwError('') : of(new UserDetailed({}));
  }

  public setSelectedUser(userId: number): Observable<number> {
    throw new Error('Method not implemented.');
  }

  public getAllDetailed(): Observable<UserDetailedInterface[]> {
    return this._alwaysError ? throwError('') : of([new UserDetailed({})]);
  }

  public findAllUsersForAssignedToList(): Observable<UserInterface[]> {
    return this.findAllUsersForAssignedToListByUserId(undefined);
  }

  public findAllUsersForAssignedToListByUserId(userId: number): Observable<UserInterface[]> {
    return this._alwaysError ? throwError('') : of([this._user]);
  }

  public findOne(id: number): Observable<UserInterface> {
    return this._alwaysError ? throwError('') : of(this._user);
  }

  public findAllAdminUsers(): Observable<UserInterface[]> {
    return this._alwaysError ? throwError('') : of([new User({})]);
  }
}

export function userServiceStubProvider(user: UserInterface, alwaysError: boolean = false): ValueProvider {
  return {
    provide: UserService,
    useValue: new UserServiceStub(user, alwaysError),
  };
}
